import React from 'react';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import ImageView from './Image';
import UnknownView from './Unknown';
import JournalView from './Journal';
import StatusView from './Status';
import LiteratureView from './Literature';
import TierView from './Tier';
import CommissionView from './Commission';
const DaEditorDeviationDumbView = (props)=>{
    let View;
    switch(getDeviationType(props.deviation)){
        // these types all have guaranteed thumb image
        case DeviationTypes.IMAGE:
        case DeviationTypes.PDF:
        case DeviationTypes.FILM:
            View = ImageView;
            break;
        case DeviationTypes.LITERATURE:
            View = LiteratureView;
            break;
        case DeviationTypes.STATUS:
            View = StatusView;
            break;
        case DeviationTypes.JOURNAL:
            View = JournalView;
            break;
        case DeviationTypes.TIER:
            View = TierView;
            break;
        case DeviationTypes.COMMISSION:
            View = CommissionView;
            break;
        default:
            View = UnknownView;
    }
    return /*#__PURE__*/ React.createElement(View, props);
};
DaEditorDeviationDumbView.displayName = 'DaEditorDeviationDumbView';
export default DaEditorDeviationDumbView;
